import React, {useContext} from "react"
import {useTranslation} from "next-i18next"
import CTA from "./CTAS/CTA"
import LayoutContext from "../../context/LayoutContext"
import {Slides} from "../reusable/components/Slides"

type Props = {
	links?:{id: number, label:string, href:string}[]
}

function EmptyWishListRightSide() {
	const {t} = useTranslation()
	const {isMobile} = useContext(LayoutContext)
	if (isMobile) {
		return <div className="col-12 d-md-none blogs-slider-wrapper ps-3">
			<Slides centerMode
				centerModePadding={{left: 0, bottom: 0, right: 25}}>

				<div key={1}
					className="row g-2">
					<div key={1}
						className={"col-12 d-flex justify-content-center mt-3"}
						style={{maxWidth: "288px"}}>
						<CTA href={"/suggestion-quiz"}
							imageSrc="/assets/icons/wishList/quiz.svg"
							btnIconSrc={"/assets/icons/question-mark-box.svg"}
							headerTitle={t("custom-offer-card-title")}
							btnLabel={t("take-quiz-btn")}
							description={t("take-short-quiz")}
							isListView={false}/>
					</div>
				</div>
				<div key={2}
					className="row g-2">
					<div key={2}
						className={"col-12 d-flex justify-content-center mt-3"}
						style={{maxWidth: "288px"}}>
						<CTA href={t("link-meeting-consultation")}
							imageSrc="/assets/icons/wishList/consultation.svg"
							btnIconSrc={"/assets/icons/calendar-consultation.svg"}
							headerTitle={t("get-contacted-card-title")}
							btnLabel={t("Beratung Buchen")}
							description={t("talk-to-our-experts-card-desc")}
							isListView={false}/>
					</div>
				</div>
			</Slides>

		</div>
	}

	return (
		<div style={{maxWidth: "636px", padding: "16px 24px", borderRadius: "16px", border: "1px solid #DEE2E6", rowGap: "16px"}}
			className="d-flex d-none d-md-block flex-column align-items-center justify-content-start">
			<div className="d-flex flex-column gap-3 justify-content-center align-items-center">
				<CTA href={"/suggestion-quiz"}
					imageSrc="/assets/icons/wishList/quiz.svg"
					btnIconSrc={"/assets/icons/question-mark-box.svg"}
					headerTitle={t("custom-offer-card-title")}
					btnLabel={t("take-quiz-btn")}
					description={t("take-short-quiz")}
					isListView={true}/>
				<div className={"col-12 mt-3"}>
					<div className={"border-top mb-2"}/>
				</div>
				<CTA href={t("link-meeting-consultation")}
					imageSrc="/assets/icons/wishList/consultation.svg"
					btnIconSrc={"/assets/icons/calendar-consultation.svg"}
					headerTitle={t("get-contacted-card-title")}
					btnLabel={t("Beratung Buchen")}
					description={t("talk-to-our-experts-card-desc")}
					isListView={true} />
			</div>
		</div>
	)
}

export default EmptyWishListRightSide
